import { PlusOutlined } from '@ant-design/icons';
import { Collapse, Layout, Typography } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { App } from '../App/App';

import { AddWantedListingForm } from './AddWantedListingForm';
import { HowItWorks } from './HowItWorks';
import { HowItWorksTiles } from './HowItWorksTiles';

const { Content } = Layout;
const { Title } = Typography;
const { Panel } = Collapse;

export const WantedListings: React.FC = () => {
  const { t } = useTranslation('wanted-listings');
  const [formOpen, setFormOpen] = useState(false);

  const handleListingAdded = () => {
    // Po dodaniu ogłoszenia można przekierować użytkownika na stronę główną
    window.location.href = '/';
  };

  return (
    <App>
      <HowItWorksTiles />
      <Layout className="bg-gray-50">
        <Content className="p-4 md:p-6 lg:p-8 max-w-7xl mx-auto w-full">
          <Title level={2} className="mb-6">
            {t('BOARD_TITLE')}
          </Title>

          <div className="mb-8 bg-white rounded-lg shadow-sm" onMouseEnter={() => setFormOpen(true)}>
            <Collapse
              ghost
              activeKey={formOpen ? ['1'] : []}
              expandIcon={({ isActive }) => <PlusOutlined rotate={isActive ? 45 : 0} />}
              onChange={(keys) => setFormOpen(keys.includes('1'))}>
              <Panel
                header={
                  <div>
                    <span className="text-lg font-medium">{t('ADD_LISTING')}</span>
                    <p className="text-sm text-gray-500 font-normal mt-1">
                      Wynajmujący zobaczą Twoje potrzeby i wyślą Ci ofertę jako propozycję umowy najmu.
                    </p>
                  </div>
                }
                key="1">
                <AddWantedListingForm onSuccess={handleListingAdded} />
              </Panel>
            </Collapse>
          </div>
        </Content>
      </Layout>
      <HowItWorks />
    </App>
  );
};
